import React, { useState, useEffect, useRef, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { updateUser } from "../../service/user"
import { updateFcmToken } from "../../service/user";
import { getWebinarByAccount } from "../../service/webinarService";
import { trackCTA } from "../../service/usercta";
import { useAuth } from "../../context/AuthContext";
import { usePageTracking } from '../../service/usercta';
import axios from "axios";

// Function to get the next weekday (skips weekends)
// const getNextWeekday = () => {
//     const today = new Date();
//     const daysToAdd = today.getDay() >= 5 ?
//         (8 - today.getDay()) : // If it's Friday or later, go to next Monday
//         (today.getDay() === 0 ? 1 : 1); // If it's Sunday, go to Monday, otherwise next day

//     const nextDay = new Date(today);
//     nextDay.setDate(today.getDate() + daysToAdd);

//     // Format: Day, Month Date (e.g., "Monday, Sep 15")
//     const options = { weekday: 'long', month: 'short', day: 'numeric' };
//     return {
//         date: nextDay.toLocaleDateString('en-US', options),
//         time: '7:30 AM',
//         duration: '30 min',
//         isWeekend: nextDay.getDay() === 0 || nextDay.getDay() === 6
//     };
// };

const getTomorrow = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    const options = { weekday: 'long', month: 'short', day: 'numeric' };
    return {
        date: tomorrow.toLocaleDateString('en-US', options),
        time: '7:30 AM',
        duration: '30 min',
        isWeekend: [0, 6].includes(tomorrow.getDay())
    };
};

import {
    Box,
    useMediaQuery,
    useTheme,
    Typography,
    Dialog,
    DialogContent,
    Chip,
    Card,
    CardContent,
    Button,
    Divider,
    DialogTitle,
    IconButton,
    Slider,
    DialogContentText,
    DialogActions,
    Paper,
    TextField
} from '@mui/material';
import { Pause, PlayArrow, VolumeUp, VolumeOff, Close, ScreenRotation } from '@mui/icons-material';
import AssessmentIcon from '@mui/icons-material/Assessment';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import WebIcon from '@mui/icons-material/Web';
import PsychologyIcon from '@mui/icons-material/Psychology';
import CloseIcon from '@mui/icons-material/Close';
import SpaIcon from '@mui/icons-material/Spa';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import InsightsIcon from '@mui/icons-material/Insights';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import Tooltip from '@mui/material/Tooltip';
import ConsultantIcon from '../../assets/Consultant.svg';
import careIcon from '../../assets/care.svg';
import cultivateIcon from '../../assets/cultivate.svg';
import WelcomeMessage from '../../components/WelcomeMessage';
import QuickActions from './QuickActions';
import EventModal from '../../components/EventModal';
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { getCurrentUser } from '../../utils/auth';
import ReactPlayer from 'react-player';
import TermsAndConditions from './YogaTermsAndCondition';

import FullscreenIcon from '@mui/icons-material/Fullscreen';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import { getPodcastForToday, getYogaVideoForToday } from '../../service/home';
import SmartBiometricTherapyDialog from './SmartBiometricTherapyDialog';

// Function to check if device is mobile - 11 nov
const isMobileDevice = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};


const MoodDisplay = () => {
    const [todayMood, setTodayMood] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Check for today's mood
        const moodData = JSON.parse(localStorage.getItem('echobuddy_mood_data') || '[]');
        const today = new Date().toISOString().split('T')[0];
        const todayEntry = moodData.find(entry => entry.date === today);

        if (todayEntry) {
            setTodayMood(todayEntry.mood);
        }
    }, []);

    if (!todayMood) return null;

    // Mood colors based on mood type
    const moodColors = {
        'Miserable': '#ef4444',
        'Horrible': '#f97316',
        'Frustrating': '#f59e0b',
        'Sad': '#fbbf24',
        'Indifferent': '#a3a3a3',
        'Neutral': '#94a3b8',
        'Happy': '#22c55e',
        'Delightful': '#10b981',
        'Blissful': '#06b6d4',
        'Exuberant': '#3b82f6'
    };

    const moodEmojis = {
        'Miserable': '😭',
        'Horrible': '😢',
        'Frustrating': '😠',
        'Sad': '😔',
        'Indifferent': '😐',
        'Neutral': '😌',
        'Happy': '😊',
        'Delightful': '😄',
        'Blissful': '😇',
        'Exuberant': '🤩'
    };

    return (
        // <Card sx={{
        //     mb: 2,
        //     p: 2,
        //     borderRadius: 3,
        //     background: `linear-gradient(135deg, ${moodColors[todayMood]}20 0%, ${moodColors[todayMood]}10 100%)`,
        //     border: `1px solid ${moodColors[todayMood]}30`
        // }}>
        //     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        //         <Box>
        //             <Typography variant="subtitle2" sx={{ color: moodColors[todayMood], fontWeight: 600, mb: 0.5 }}>
        //                 Today's Mood
        //             </Typography>
        //             <Typography variant="h6" sx={{ color: moodColors[todayMood], fontWeight: 700 }}>
        //                 {todayMood} {moodEmojis[todayMood]}
        //             </Typography>
        //         </Box>
        //         <Button
        //             variant="outlined"
        //             size="small"
        //             onClick={() => navigate('/mood-checkin')}
        //             sx={{
        //                 borderColor: moodColors[todayMood],
        //                 color: moodColors[todayMood],
        //                 '&:hover': {
        //                     backgroundColor: `${moodColors[todayMood]}10`,
        //                     borderColor: moodColors[todayMood]
        //                 }
        //             }}
        //         >
        //             Update
        //         </Button>
        //     </Box>
        // </Card>
        <Box
            sx={{
                mb: 1.5,
                p: 2,
                borderRadius: 3,
                backdropFilter: 'blur(8px)',
                background: `linear-gradient(135deg, #f9f9f912 0%, #f9f9f905 100%)`,
                border: '2px solid #e0e0e0', // light gray border
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', // ✅ soft light shadow
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                    border: '2px solid #bdbdbd', // slightly darker on hover
                    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)' // ✅ deeper shadow on hover
                }
            }}
        >
            <Box>
                {/* Top Row: Title + Button */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mb: 0.4
                    }}
                >
                    <Typography
                        variant="subtitle1"
                        sx={{
                            color: moodColors[todayMood],
                            letterSpacing: 0.2,
                            fontWeight: 600,
                            fontSize: { xs: '15px', sm: '16px' }
                        }}
                    >
                        Today's Mood
                    </Typography>

                    <Button
                        variant="contained"
                        size="small"
                        onClick={() => navigate('/mood-checkin')}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 500,
                            fontSize: '0.75rem',
                            borderRadius: 1.5,
                            px: 1.5,
                            py: 0.3,
                            minWidth: 'auto',
                            backgroundColor: `${moodColors[todayMood]}25`,
                            color: moodColors[todayMood],
                            border: `1px solid ${moodColors[todayMood]}35`,
                            backdropFilter: 'blur(5px)',
                            transition: 'all 0.25s ease-in-out',
                            '&:hover': {
                                backgroundColor: `${moodColors[todayMood]}40`,
                                boxShadow: `0 0 8px ${moodColors[todayMood]}40`,
                                transform: 'scale(1.04)'
                            }
                        }}
                    >
                        Update
                    </Button>
                </Box>

                {/* Bottom Row: Mood */}
                <Typography
                    variant="body2"
                    sx={{
                        color: '#64748B',
                        fontSize: { xs: '13.5px', sm: '15px' },
                        fontWeight: 500,
                        lineHeight: 1.5,
                        letterSpacing: '0.01em'
                    }}
                >
                    {moodEmojis[todayMood?.label]} {todayMood?.label}
                    {moodEmojis[todayMood?.emoji]} {todayMood?.emoji}
                </Typography>
            </Box>
        </Box>

    );
};

const Home = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const [open, setOpen] = useState(false);
    const phoneNumber = "9999666555";
    const _institution = localStorage.getItem('institution') || '';
    console.log('[Home] institution from localStorage:', JSON.stringify(_institution));
    const isRvce = _institution.toLowerCase().includes('rvce');
    const [isPodcastOpen, setIsPodcastOpen] = useState(false);
    const [eventModalOpen, setEventModalOpen] = useState(false);
    const [isTermsOpen, setIsTermsOpen] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [isYogaVideoOpen, setIsYogaVideoOpen] = useState(false);
    const [scheduledVideo, setScheduledVideo] = useState(null);
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);
    const [isWebinarRegistered, setIsWebinarRegistered] = useState(false);
    const [isInsightsComingSoonOpen, setIsInsightsComingSoonOpen] = useState(false);
    const videoRef = useRef(null);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [volume, setVolume] = useState(0.7);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const videoContainerRef = useRef(null);
    const containerRef = useRef(null);
    const [isLandscape, setIsLandscape] = useState(false);
    const [muted, setMuted] = useState(true);
    const [showContactPopup, setShowContactPopup] = useState(false);
    const [webinarData, setWebinarData] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [podcast, setPodcast] = useState(null);
    const [currentUser, setCurrentUser] = useState(getCurrentUser());
    usePageTracking();

    const handleListenNow = async () => {
        try {
            const data = await getPodcastForToday();
            setPodcast(data);

            handleEventAction('podcast'); // keep your existing logic
        } catch (err) {
            console.log("Failed to load podcast");
        }
    };

    // webinar useeffect
    useEffect(() => {
        const fetchWebinar = async () => {
            // Refresh currentUser to get latest data from localStorage
            const freshUser = getCurrentUser();
            setCurrentUser(freshUser);

            // Debug: Show all available fields in currentUser
            console.log('All currentUser fields:', Object.keys(freshUser || {}));
            console.log('currentUser values:', freshUser);

            // Handle both accountId and account_id to cover all cases
            let accountId = freshUser?.accountId;
            if (accountId === undefined && freshUser !== null) {
                // If accountId is undefined, check if we can get account_id from raw localStorage
                const rawUserStr = localStorage.getItem('user');
                const rawUser = rawUserStr ? JSON.parse(rawUserStr) : null;
                accountId = rawUser?.account_id;
            }

            console.log('Fetching webinar for account:', accountId);
            console.log('Final account_id:', accountId, typeof accountId);

            if (accountId === undefined || accountId === null) {
                console.log('No account_id found in user data');
                setWebinarData(null);
                return;
            }

            try {
                console.log('Making API call to get webinar...');
                const webinar = await getWebinarByAccount(accountId);
                console.log('Webinar data received:', webinar);

                // The service now returns a single webinar object (or null)
                setWebinarData(webinar);
            } catch (error) {
                console.error('Error fetching webinar:', error);
                setWebinarData(null);
            }
        };

        fetchWebinar();
    }, []); // Remove currentUser dependency to prevent infinite loops


    const toggleMute = () => {
        if (videoRef.current) {
            videoRef.current.muted = !videoRef.current.muted;
            setMuted(videoRef.current.muted);
        }
    };

    // useEffect(() => {
    //     // Create global function so Flutter can call it
    //     window.receiveDataFromApp = ({ token, userId, email }) => {
    //         console.log("🔥 Data received from Flutter:", { token, userId, email });

    //         // Store data in localStorage
    //         localStorage.setItem("firebaseToken", token);
    //         localStorage.setItem("userId", userId);
    //         localStorage.setItem("email", email);

    //         // Show alert
    //         alert(`Firebase Token: ${token}\nUser ID: ${userId}\nEmail: ${email}`);
    //     };
    // }, []);


    //    25 nov
    useEffect(() => {
        // Create global function so Flutter can call it
        window.receiveDataFromApp = async ({ token, userId, email }) => {
            console.log("🔥 Data received from Flutter:", { token, userId, email });

            // Store data in localStorage
            localStorage.setItem("firebaseToken", token);
            localStorage.setItem("userId", userId);
            localStorage.setItem("email", email);

            // Call backend to save FCM token
            try {
                const result = await updateFcmToken(userId, token);
                console.log("📡 Backend Response:", result);

                console.log(`Firebase Token Saved!\nToken: ${token}\nUser ID: ${userId}\nMessage: ${result.message}`)
                // alert(
                //     `Firebase Token Saved!\nToken: ${token}\nUser ID: ${userId}\nMessage: ${result.message}`
                // );
            } catch (err) {
                console.error("❌ Error updating FCM token:", err);
                alert(`Failed to save FCM token to backend.\n${err.message}`);
            }
        };
    }, []);




    //12 nov 
    // const handleFullscreenToggle = async () => {
    //     if (!containerRef.current) return; // Changed from videoRef.current to containerRef.current
    //     console.log('Toggling fullscreen. Current state:', isFullscreen);
    //     try {
    //         if (document.fullscreenElement || document.webkitFullscreenElement) {
    //             // Exit fullscreen
    //             if (document.exitFullscreen) {
    //                 await document.exitFullscreen();
    //             } else if (document.webkitExitFullscreen) {
    //                 await document.webkitExitFullscreen();
    //             }
    //             setIsFullscreen(false);
    //         } else {
    //             // Enter fullscreen on the container (which includes video + buttons)
    //             const element = containerRef.current; // Changed from videoRef.current to containerRef.current
    //             if (element.requestFullscreen) {
    //                 await element.requestFullscreen();
    //             } else if (element.webkitRequestFullscreen) {
    //                 await element.webkitRequestFullscreen();
    //             }
    //             setIsFullscreen(true);
    //         }
    //     } catch (err) {
    //         console.error('Fullscreen error:', err);
    //     }
    // };

    // const handleFullscreenToggle = async () => {
    //     if (!containerRef.current) return;

    //     try {
    //         if (document.fullscreenElement || document.webkitFullscreenElement) {
    //             await handleFullscreenExit();  // <-- call it here
    //         } else {
    //             const element = containerRef.current;
    //             if (element.requestFullscreen) await element.requestFullscreen();
    //             else if (element.webkitRequestFullscreen) await element.webkitRequestFullscreen();

    //             setIsFullscreen(true);

    //             // Lock landscape on mobile
    //             if (isMobileDevice() && screen.orientation?.lock) {
    //                 await screen.orientation.lock('landscape');
    //             }
    //         }
    //     } catch (err) {
    //         console.error('Fullscreen error:', err);
    //     }
    // };

    const handleFullscreenToggle = async () => {
        if (!containerRef.current) return;

        try {
            if (document.fullscreenElement || document.webkitFullscreenElement) {
                await handleFullscreenExit();  // exit logic already handles state
            } else {
                const element = containerRef.current;

                // Optimistically set state before async operations
                setIsFullscreen(true);

                if (element.requestFullscreen) await element.requestFullscreen();
                else if (element.webkitRequestFullscreen) await element.webkitRequestFullscreen();

                // Lock landscape on mobile (async)
                if (isMobileDevice() && screen.orientation?.lock) {
                    try {
                        await screen.orientation.lock('landscape');
                    } catch (err) {
                        console.warn('Orientation lock failed:', err);
                    }
                }
            }
        } catch (err) {
            console.error('Fullscreen error:', err);
            // Revert state if something fails
            setIsFullscreen(false);
        }
    };

    const handleFullscreenExit = async () => {
        // Optimistically update state first
        setIsFullscreen(false);

        try {
            if (document.fullscreenElement || document.webkitFullscreenElement) {
                if (document.exitFullscreen) await document.exitFullscreen();
                else if (document.webkitExitFullscreen) await document.webkitExitFullscreen();
            }

            // Unlock orientation back to default
            if (screen.orientation && screen.orientation.unlock) {
                screen.orientation.unlock();
            }
            document.body.style.overflow = '';
        } catch (err) {
            console.error('Error exiting fullscreen:', err);
            // If exit failed, you might want to revert state
            setIsFullscreen(true);
        }
    };


    // const handlePlay = async () => {
    //     if (!videoRef.current) return;

    //     if (isIOS() && videoRef.current.webkitEnterFullscreen) {
    //         // iOS fullscreen (usually landscape automatically)
    //         videoRef.current.webkitEnterFullscreen();
    //     } else if (isMobileDevice()) {
    //         try {
    //             // Android / other mobile: request fullscreen
    //             await handleFullscreenToggle();

    //             // Lock orientation to landscape if supported
    //             if (screen.orientation && screen.orientation.lock) {
    //                 await screen.orientation.lock('landscape');
    //             }
    //         } catch (err) {
    //             console.warn('Fullscreen or orientation error:', err);
    //         }
    //     }
    // };


    // 13 nov 
    const handlePlay = async () => {
        if (!videoRef.current) return;

        if (isIOS()) {
            // 🔥 iOS: use fake fullscreen instead of native Safari player
            setIsFullscreen(true);
            document.body.style.overflow = 'hidden'; // prevent background scroll
        } else if (isMobileDevice()) {
            try {
                // Android / other mobile: request real fullscreen
                await handleFullscreenToggle();

                // Lock orientation to landscape if supported
                if (screen.orientation && screen.orientation.lock) {
                    await screen.orientation.lock('landscape');
                }
            } catch (err) {
                console.warn('Fullscreen or orientation error:', err);
            }
        }
    };

    const isIOS = () => {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    };

    // const handleFullscreenToggle = () => {
    //     if (!document.fullscreenElement) {
    //         // Enter fullscreen
    //         containerRef.current?.requestFullscreen?.();
    //     } else {
    //         // Exit fullscreen
    //         document.exitFullscreen?.();
    //     }
    // };

    useEffect(() => {
        // Check for account_id in localStorage
        const accountId = localStorage.getItem("account_id");
        console.log("Account ID from localStorage:", accountId);

        if (!accountId) {
            console.error("No account_id found in localStorage");
            // You might want to redirect to login or show an error message
            // navigate('/login');
        }

        // Rest of your existing useEffect logic can go here
    }, [navigate]); // Add any other dependencies your effect might need

    // Check user's webinar registration status on component mount
    useEffect(() => {
        if (currentUser && currentUser.webinarStatus === 'registered') {
            setIsWebinarRegistered(true);
        }
    }, [currentUser]); // ✅ run whenever currentUser changes



    // Import the WellnessDisplay component
    const WellnessDisplay = React.lazy(() => import('./WellnessDisplay'));


    // Day of week schedule (0 = Sunday, 1 = Monday, etc.)
    const yogaVideoDaySchedule = {
        0: { title: 'Sunday Relaxation', description: 'Gentle weekend flow' },
        1: { title: 'Monday Energizer', description: 'Start the week strong' },
        2: { title: 'Tuesday Balance', description: 'Find your center' },
        3: { title: 'Wednesday Wellness', description: 'Midweek mindfulness' },
        4: { title: 'Thursday Strength', description: 'Build inner strength' },
        5: { title: 'Friday Flow', description: 'End the week peacefully' },
        6: { title: 'Saturday Stretch', description: 'Weekend rejuvenation' },
    };

    // const getScheduledVideo = () => {
    //     const today = new Date();
    //     // const today = new Date("2025-11-04");
    //     const dateString = today.toISOString().split("T")[0]; // "YYYY-MM-DD"
    //     const dayOfWeek = today.getDay();

    //     // Find the matching video by date prefix
    //     const videoFile = yogaVideos.find((file) => file.startsWith(dateString));

    //     if (!videoFile) return null;

    //     // Extract video title (remove date and extension)
    //     const extractedTitle = videoFile
    //         .replace(/^\d{4}-\d{2}-\d{2}\s*/, "")
    //         .replace(".mp4", "");

    //     // Title/description from day schedule
    //     const daySchedule = yogaVideoDaySchedule[dayOfWeek] || {
    //         title: `Yoga Session for ${dateString}`,
    //         description: `Daily yoga video for ${dateString}`,
    //     };

    //     return {
    //         video: `/videos/${videoFile}`,
    //         title: extractedTitle || daySchedule.title,
    //         description: daySchedule.description,
    //     };
    // };


    // Load scheduled video when component mounts

    const getScheduledVideo = async () => {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const dd = String(today.getDate()).padStart(2, "0");
        const formattedDate = `${yyyy}${mm}${dd}`; // → yyyymmdd
        // const formattedDate = 20251205; // → yyyymmdd

        try {
            const response = await getYogaVideoForToday(formattedDate);
            return {
                video: response.track_url,
                title: `Yoga Session - ${formattedDate}`,
                description: `Your scheduled yoga session`,
            };
        } catch (error) {
            console.error("Error fetching today's yoga video:", error);
            return null;
        }
    };

    useEffect(() => {
        const fetchVideo = async () => {
            const data = await getScheduledVideo();
            setScheduledVideo(data);
        };
        fetchVideo();
    }, []);

    // useEffect(() => {
    //     setScheduledVideo(getScheduledVideo());
    // }, []);

    const getVideoStartTimeOffset = () => {
        const now = new Date();
        const startTime = new Date();
        // startTime.setHours(7, 30, 0, 0); // 7:30 AM
        startTime.setHours(7, 0, 0, 0); // 7:30 AM


        const endTime = new Date();

        endTime.setHours(23, 59, 0, 0); // 8:00 AM

        if (now < startTime) return 0;
        if (now >= endTime) return 0; // For testing: video will play from start
        return (now - startTime) / 1000; // offset in seconds
    };

    // const handleServiceClick = (service) => {
    //     if (service.serviceType === 'consult') {
    //         navigate('/consult');

    //     } else if (service.serviceType === 'care') {
    //         navigate('/care');
    //     } else if (service.serviceType === 'converse') {
    //         navigate('/converse');
    //     }
    // };
    //     const handleServiceClick = (service) => {
    //     if (service.serviceType === 'consult') {
    //         const accountId = localStorage.getItem('account_id');
    //         if (accountId === '5') {
    //             setShowContactPopup(true);
    //         } else {
    //             navigate('/consult');
    //         }
    //     } else if (service.serviceType === 'care') {
    //         navigate('/care');
    //     } else if (service.serviceType === 'converse') {
    //         navigate('/converse');
    //     }
    // };
    //commented by me 

    const handleServiceClick = (service) => {
        const user = JSON.parse(localStorage.getItem('user'));
        const serviceName = service.serviceType;

        trackCTA(`${serviceName}`, user);

        const accountId = localStorage.getItem('account_id');

        if (service.serviceType === 'consult') {
            if (accountId === '5') {
                setShowContactPopup(true);
            } else {
                navigate('/consult');
            }
        } else if (service.serviceType === 'care') {
            navigate('/care');
        } else if (service.serviceType === 'converse') {
            navigate('/converse');
        }
    };

    // const handleServiceClick = (service) => {
    //     const user = JSON.parse(localStorage.getItem('user'));
    //     const serviceName = service.serviceType; // 'consult', 'care', or 'converse'

    //     // Track the CTA click
    //     trackCTA(`${serviceName}`, user);
    //     console.log(`CTA tracked: ${serviceName}`, user);

    //     const accountId = localStorage.getItem('account_id');
    //     console.log('Current account_id:', accountId);

    //     if (service.serviceType === 'consult') {
    //         if (accountId === '5') {
    //             setShowContactPopup(true);
    //         } else {

    //             window.location.href = '/consult';
    //         }
    //     } else if (service.serviceType === 'care') {
    //         window.location.href = '/care';
    //         // Remove: trackCTA('care', user); // Already tracked above
    //     } else if (service.serviceType === 'converse') {
    //         window.location.href = '/converse';
    //         // Remove: trackCTA('converse', user); // Already tracked above
    //     }
    // };

    const handleCloseContactPopup = () => {
        setShowContactPopup(false);
    };

    const handleEventAction = (type) => {
        console.log("Button clicked:", type);  // Check if this logs
        const user = JSON.parse(localStorage.getItem('user'));
        console.log("User from localStorage:", user);  // Verify user data
        trackCTA(type, user);

        if (type === 'podcast') {

            setIsPodcastOpen(true);
            return;
        }

        if (type === 'yoga') {
            // Get the user from localStorage
            const storedUser = JSON.parse(localStorage.getItem('user'));
            const yogaAccepted = storedUser?.yoga_terms_conditions === true;

            if (yogaAccepted) {

                // Terms already accepted → directly open video
                setIsYogaVideoOpen(true);
            } else {
                // Terms not accepted → open Terms & Conditions dialog
                setIsTermsOpen(true);
            }
            return;
        }

        // Handle other event types
        setSelectedEvent(type);
        setEventModalOpen(true);
    };

    const handleCloseEventModal = () => {
        setEventModalOpen(false);
        setSelectedEvent(null);
    };

    const handleClick = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleDialNow = () => {
        window.location.href = `tel:${phoneNumber}`;
        setOpen(false);
    };

    //yoga terms
    const handleAcceptYogaTerms = async () => {
        try {
            //  Parse user from localStorage (string → object)
            const storedUser = JSON.parse(localStorage.getItem("user"));

            if (!storedUser?.id || !storedUser?.account_id) {
                console.error(" No valid user data found in localStorage");
                return;
            }



            // ✅ Prepare payload for API
            const payload = {
                account_id: storedUser.account_id,
                yoga_terms_conditions: true,
            };

            console.log("📤 Sending payload:", payload);

            //  Send update to backend
            const response = await updateUser(storedUser.id, payload);
            console.log(" Yoga terms updated successfully:", response);
            // ✅ Update the value to true
            storedUser.yoga_terms_conditions = true;

            //  Save updated user back to localStorage
            localStorage.setItem("user", JSON.stringify(storedUser));
            localStorage.setItem("yogaTermsAccepted", "true");

            //  Close modal and open video
            setIsTermsOpen(false);
            setIsYogaVideoOpen(true);
        } catch (error) {
            console.error(" Failed to update yoga terms:", error);
        }
    };

    // Get user info from localStorage
    const storedUser = localStorage.getItem("user");
    const user = storedUser ? JSON.parse(storedUser) : null;
    const userName = user?.name || "Guest";

    return (
        <Box
            sx={{
                background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
                minHeight: {
                    xs: 'calc(100vh - 56px)',
                    sm: 'calc(100vh - 64px)',
                    md: 'calc(100vh - 70px)',
                },
            }}
        >
            <Box sx={{
                maxWidth: 1200,
                margin: '0 auto',
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                minHeight: 'calc(100vh - 150px)',
                background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
            }}>
                {/* Header Row - Welcome Message, Today's Mood, and Action Icons */}
                <Box sx={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    alignItems: isMobile ? 'flex-start' : 'center',
                    justifyContent: 'space-between',
                    gap: isMobile ? 0 : 3,
                    mb: { xs: 2, sm: 1 },
                    width: '100%'
                }}>
                    <Box sx={{ flex: 1 }}>
                        <WelcomeMessage userName={userName} />
                    </Box>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        alignItems: isMobile ? 'stretch' : 'center',
                        gap: isMobile ? 0 : 3,
                        width: isMobile ? '100%' : 'auto',
                        flexShrink: 0
                    }}>
                        {/* <Box sx={{
                            minWidth: isMobile ? '100%' : '280px',
                            maxWidth: isMobile ? '100%' : '320px',
                            order: isMobile ? 1 : 0,
                        }}>
                            <MoodDisplay />
                        </Box> */}
                        {/* Action Icons */}
                        <Box sx={{
                            display: 'flex',
                            gap: isMobile ? 2 : 1.5,
                            justifyContent: isMobile ? 'center' : 'flex-end',
                            order: isMobile ? 2 : 1,
                            flexWrap: 'wrap'
                        }}>
                            <Tooltip title="Insights" arrow>
                                <IconButton
                                    // onClick={() => setIsInsightsComingSoonOpen(true)}
                                    onClick={() => navigate("/insights")}
                                    sx={{
                                        width: isMobile ? 38 : 44,
                                        height: isMobile ? 38 : 44,
                                        // backgroundColor: 'rgba(74, 108, 247, 0.1)',
                                        '&:hover': {
                                            backgroundColor: 'rgba(74, 108, 247, 0.2)',
                                            transform: 'scale(1.05)'
                                        },
                                        transition: 'all 0.2s ease',
                                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                        color: '#fff',
                                    }}
                                >
                                    <InsightsIcon fontSize={isMobile ? "small" : "small"} />
                                </IconButton>
                            </Tooltip>
                            {!isRvce && (
                                <Tooltip title="My Appointments" arrow>
                                    <IconButton
                                        onClick={() => navigate('/appointments')}
                                        sx={{
                                            width: isMobile ? 38 : 44,
                                            height: isMobile ? 38 : 44,
                                            // backgroundColor: 'rgba(34, 197, 94, 0.1)',
                                            // color: '#22c55e',
                                            color: '#fff',
                                            '&:hover': {
                                                backgroundColor: 'rgba(34, 197, 94, 0.2)',
                                                transform: 'scale(1.05)'
                                            },
                                            transition: 'all 0.2s ease',
                                            background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',

                                        }}
                                    >
                                        <CalendarTodayIcon fontSize={isMobile ? "small" : "small"} />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {/* <Tooltip title="Family Details" arrow>
                                <IconButton
                                    onClick={() => navigate('/family')}
                                    sx={{
                                        width: isMobile ? 38 : 44,
                                        height: isMobile ? 38 : 44,
                                        // backgroundColor: 'rgba(168, 85, 247, 0.1)',
                                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                        // color: '#a855f7',
                                        color: '#fff',
                                        '&:hover': {
                                            backgroundColor: 'rgba(168, 85, 247, 0.2)',
                                            transform: 'scale(1.05)'
                                        },
                                        transition: 'all 0.2s ease'
                                    }}
                                >
                                    <FamilyRestroomIcon fontSize={isMobile ? "small" : "small"} />
                                </IconButton>
                            </Tooltip> */}
                        </Box>
                    </Box>
                </Box>

                <Box display="flex" gap="20px">
                    <Box>
                        <Card
                            sx={{
                                maxWidth: '798px',
                                cursor: 'pointer',
                                transition: 'all 0.3s',
                                '&:hover': {
                                    transform: 'translateX(4px)',
                                    boxShadow: 3,
                                    borderColor: 'primary.main'
                                },
                                borderRadius: 3,
                                border: '1px solid #e0e0e0',
                                p: 2,               // reduced padding
                                mb: 1.5,              // reduced margin
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                gap: 1,               // reduced gap
                                textAlign: 'left',
                                background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
                            }}
                        >
                            <Typography variant="h6" fontWeight={600} sx={{
                                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                            }}>
                                🎵 AI-Powered Sound Therapy
                            </Typography>

                            <Typography variant="body2" color="text.secondary">
                                Based on your mood and heart rate, echoBuddy designs personalized therapeutic
                                music to elevate your mind and well-being.
                            </Typography>

                            <Button
                                variant="contained"
                                onClick={() => navigate("/echo-sounds")}
                                sx={{
                                    mt: 0.5,
                                    borderRadius: 2,
                                    textTransform: "none",
                                    fontWeight: 600,
                                    fontSize: "12px",     // ↓ smaller text
                                    px: 1.5,              // ↓ shorter width padding
                                    py: 0.3,              // ↓ shorter height padding
                                    minWidth: "auto",      // removes MUI default 64px width
                                    background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',

                                }}
                            >
                                Start Your Journey
                            </Button>

                        </Card>

                        <Box sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: { xs: 3, sm: 2, md: 3 },
                            alignItems: 'stretch',
                            width: '100%',
                            minHeight: '290px'
                        }}>
                            {/* Left Column - Service Cards (40% width) */}
                            <Box sx={{
                                flex: isMobile ? '1 1 100%' : '1 1 40%',
                                width: '100%',
                                maxWidth: isMobile ? '100%' : '48%',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2,
                                '& > *': {
                                    flexShrink: 0
                                }
                            }}>
                                {[
                                    {
                                        icon: careIcon,
                                        title: "Care",
                                        desc: "Your Daily Wellness Companion",
                                        serviceType: "care"
                                    },
                                    ...(!isRvce ? [{
                                        icon: cultivateIcon,
                                        title: "Converse",
                                        desc: "24/7 Support with our Counsellors",
                                        serviceType: "converse"
                                    },
                                    {
                                        icon: ConsultantIcon,
                                        title: "Consult",
                                        desc: "Book your Appointment",
                                        serviceType: "consult"
                                    }] : [])].map((item, idx) => (
                                        <Card
                                            key={idx}
                                            onClick={() => handleServiceClick(item)}
                                            sx={{
                                                width: '100%',
                                                cursor: 'pointer',
                                                transition: 'all 0.3s',
                                                '&:hover': {
                                                    transform: 'translateX(4px)',
                                                    boxShadow: 3,
                                                    borderColor: 'primary.main'
                                                },
                                                borderRadius: 3,
                                                border: '1px solid #e0e0e0',
                                                p: 2,
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                gap: 2,
                                                textAlign: 'left',
                                                position: "relative",
                                            }}
                                        >
                                            {item.title === "Care" && !isRvce && (
                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: -2,
                                                        right: 0,
                                                    }}
                                                >
                                                    <Chip
                                                        label="Daily Yoga"
                                                        variant="filled"
                                                        onClick={(e) => {
                                                            e.stopPropagation(); // prevent card click
                                                            navigate("/care", {
                                                                state: { showYoga: true }
                                                            });
                                                        }}
                                                        sx={{
                                                            // backgroundColor: "#4CAF50",
                                                            background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                                            color: "#fff",
                                                            fontSize: "14px",
                                                            height: "26px",
                                                            px: 0.5,
                                                            borderRadius: "6px",
                                                            fontWeight: 500,
                                                            cursor: "pointer",
                                                            "&:hover": {
                                                                backgroundColor: "#4CAF50", // same as normal
                                                            },
                                                            "&.MuiChip-clickable:hover": {
                                                                backgroundColor: "#4CAF50",
                                                            }
                                                        }}
                                                    />
                                                </Box>
                                            )}
                                            {/* {item.title === "Converse" && (
                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: -2,
                                                        right: 0,
                                                    }}
                                                >
                                                    <Chip
                                                        label="24/7 Chat Support"
                                                        variant="filled"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            window.location.href = '/converse';
                                                        }}
                                                        sx={{
                                                            background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                                            color: "#fff",
                                                            fontSize: "14px",
                                                            height: "26px",
                                                            px: 0.5,
                                                            borderRadius: "6px",
                                                            fontWeight: 500,
                                                            cursor: "pointer",
                                                            "&:hover": {
                                                                backgroundColor: "#4CAF50",
                                                            },
                                                            "&.MuiChip-clickable:hover": {
                                                                backgroundColor: "#4CAF50",
                                                            }
                                                        }}
                                                    />
                                                </Box>
                                            )} */}
                                            {item.title === "Converse" && (
                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: -2,
                                                        right: 0,
                                                    }}
                                                >
                                                    <Chip
                                                        label="24/7 Chat Support"
                                                        variant="filled"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            navigate('/converse');   // ✅ client-side navigation, no reload
                                                        }}
                                                        sx={{
                                                            background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                                            color: "#fff",
                                                            fontSize: "14px",
                                                            height: "26px",
                                                            px: 0.5,
                                                            borderRadius: "6px",
                                                            fontWeight: 500,
                                                            cursor: "pointer",
                                                            "&:hover": {
                                                                backgroundColor: "#4CAF50",
                                                            },
                                                            "&.MuiChip-clickable:hover": {
                                                                backgroundColor: "#4CAF50",
                                                            }
                                                        }}
                                                    />
                                                </Box>
                                            )}
                                            <Box sx={{
                                                width: 40,
                                                height: 40,
                                                borderRadius: '50%',
                                                backgroundColor: 'rgba(106, 115, 168, 0.1)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flexShrink: 0
                                            }}>
                                                <img src={item.icon} alt={item.title} style={{ width: 24, height: 24 }} />
                                            </Box>
                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <Typography
                                                    variant="subtitle1"
                                                    fontWeight={800}
                                                    sx={{
                                                        color: '#6A73A8',
                                                        fontSize: { xs: '14px', sm: '16px' },
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis'
                                                    }}
                                                >
                                                    {item.title}
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: '#8A8A8E',
                                                        fontSize: { xs: '12px', sm: '14px' },
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis'
                                                    }}
                                                >
                                                    {item.desc}
                                                </Typography>
                                            </Box>

                                            <ArrowForwardIosIcon sx={{
                                                fontSize: { xs: 16, sm: 18 },
                                                color: '#103680',
                                                flexShrink: 0
                                            }} />
                                        </Card>
                                    ))}
                            </Box>

                            {/* Vertical Divider */}
                            {!isMobile && <Divider orientation="vertical" flexItem />}

                            {/* Center Column - Mood & Wellness (30% width) */}
                            <Box sx={{
                                flex: isMobile ? '1 1 100%' : '1 1 30%',
                                width: '100%',
                                maxWidth: isMobile ? '100%' : '48%',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: { xs: 2, sm: 2.5 },
                                '& > *': {
                                    flexShrink: 0
                                }
                            }}>
                                {/* Daily Wellness Tip - Compact */}
                                <Card sx={{
                                    p: 2.5,
                                    borderRadius: 3,
                                    background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
                                    border: '1px solid #bae6fd',
                                    boxShadow: '0 2px 12px rgba(14, 165, 233, 0.08)',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 4px 20px rgba(14, 165, 233, 0.15)'
                                    }
                                }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                                        <Box sx={{
                                            width: 32,
                                            height: 32,
                                            borderRadius: '8px',
                                            background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            mr: 1.5
                                        }}>
                                            <LightbulbIcon sx={{ color: 'white', fontSize: 16 }} />
                                        </Box>
                                        <Typography variant="subtitle2" sx={{ color: '#0c4a6e', fontWeight: 600, fontSize: '0.9rem' }}>
                                            Daily Wellness Tip
                                        </Typography>
                                    </Box>
                                    <Suspense fallback={<div>Loading tip...</div>}>
                                        <WellnessDisplay variant="compact" />
                                    </Suspense>
                                </Card>

                                {/* Quick Actions */}
                                {/* <QuickActions /> */}

                                {/* Wellness Assessment Card */}
                                <Card sx={{
                                    p: 0, borderRadius: 3, background: '#ffffff',
                                    border: '1px solid #f0f2f5', boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                                    transition: 'all 0.3s ease',
                                    '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 8px 25px rgba(0,0,0,0.08)' }
                                }}>
                                    <CardContent sx={{ p: 2.5 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                                            <Box sx={{ width: 38, height: 38, borderRadius: '10px', backgroundColor: 'rgba(74,108,247,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1.5, flexShrink: 0 }}>
                                                <AssessmentIcon sx={{ color: '#4a6cf7', fontSize: 20 }} />
                                            </Box>
                                            <Typography variant="subtitle1" sx={{ color: '#2c3e50', fontWeight: 700, fontSize: '0.95rem' }}>
                                                Wellness Assessment
                                            </Typography>
                                        </Box>
                                        <Typography variant="body2" sx={{ color: '#6b7c93', mb: 2, fontSize: '0.82rem', lineHeight: 1.5 }}>
                                            Evaluate your overall well-being with our comprehensive assessment
                                        </Typography>
                                        <Button
                                            variant="contained"
                                            fullWidth
                                            onClick={() => { const u = JSON.parse(localStorage.getItem('user')); trackCTA('wellness_assessment', u); navigate('/choose-assessment'); }}
                                            sx={{
                                                py: 1, borderRadius: 2, textTransform: 'none', fontWeight: 600,
                                                fontSize: '0.85rem', color: '#fff', border: 'none',
                                                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                                boxShadow: '0 4px 15px rgba(34,197,94,0.25)',
                                                '&:hover': { opacity: 0.92, boxShadow: '0 6px 20px rgba(34,197,94,0.35)' }
                                            }}
                                        >
                                            Start Assessment
                                        </Button>
                                    </CardContent>
                                </Card>
                            </Box>

                        </Box>



                        {isTablet && (
                            <Box sx={{
                                flex: isTablet ? '1 1 100%' : '1 1 30%',
                                width: '100%',
                                maxWidth: isTablet ? '100%' : '30%',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: { xs: 2, sm: 2.5 },
                                '& > *': {
                                    flexShrink: 0
                                }
                            }}>
                                {/* Upcoming Events Header - Compact */}
                                <Box sx={{
                                    display: 'flex', alignItems: 'center', my: 2, p: 1.5, background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                    borderRadius: 2, boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)', border: '1px solid #e3f2fd', color: '#fff',
                                }}>
                                    <EventAvailableIcon sx={{ color: '#fff', mr: 1, fontSize: 20 }} />
                                    <Typography variant="subtitle1" sx={{ color: '#fff', fontWeight: 600, fontSize: '0.95rem', }}>
                                        Events
                                    </Typography>
                                </Box>

                                <Box sx={{ display: 'grid', gap: { xs: 1.5, sm: 2 } }}>
                                    {isRvce && (
                                        /* Monthly Engagement Card (RVCE) */
                                        <Card
                                            elevation={0}
                                            sx={{
                                                p: 2,
                                                borderRadius: 2.5,
                                                border: '1px solid #E5E7EB',
                                                background: 'linear-gradient(135deg, #f0fff4 0%, #e6ffed 100%)',
                                                transition: 'all 0.3s ease-in-out',
                                                '&:hover': {
                                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                                    transform: 'translateY(-1px)'
                                                }
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                                <Box sx={{
                                                    width: 36,
                                                    height: 36,
                                                    borderRadius: 2,
                                                    background: 'linear-gradient(135deg, #22c55e, #14b8a6)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    mr: 1.5,
                                                    flexShrink: 0,
                                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                                }}>
                                                    <EventAvailableIcon sx={{ color: 'white', fontSize: 18 }} />
                                                </Box>
                                                <Box sx={{ flex: 1 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#166534', mb: 0.5, fontSize: '0.9rem' }}>
                                                            Monthly Engagement
                                                        </Typography>
                                                        <Chip
                                                            label="Monthly"
                                                            size="small"
                                                            sx={{
                                                                height: 18,
                                                                fontSize: '0.6rem',
                                                                fontWeight: 600,
                                                                bgcolor: '#dcfce7',
                                                                color: '#166534',
                                                                '& .MuiChip-label': { p: '0 6px' },
                                                                borderRadius: 1
                                                            }}
                                                        />
                                                    </Box>
                                                    <Typography variant="body2" sx={{ color: '#5f6368', fontSize: '0.81rem', mb: 1 }}>
                                                        No sessions scheduled at the moment.
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ color: '#5f6368', fontSize: '0.7rem', display: 'block', lineHeight: 1.4 }}>
                                                        Stay tuned for upcoming engagement activities!
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Card>
                                    )}
                                    {!isRvce && (
                                        <Card
                                            elevation={0}
                                            sx={{
                                                p: 2,
                                                borderRadius: 2.5,
                                                border: '1px solid #E5E7EB',
                                                background: 'linear-gradient(135deg, #f0f7ff 0%, #e1f0ff 100%)',
                                                transition: 'all 0.3s ease-in-out',
                                                '&:hover': {
                                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                                    transform: 'translateY(-1px)'
                                                }
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                                <Box sx={{
                                                    width: 36,
                                                    height: 36,
                                                    borderRadius: 2,
                                                    background: 'linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    mr: 1.5,
                                                    flexShrink: 0,
                                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                                }}>
                                                    <WebIcon sx={{ color: 'white', fontSize: 18 }} />
                                                </Box>
                                                {/* <Box sx={{ flex: 1 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#0d47a1', mb: 0.5, fontSize: '0.9rem' }}>
                                                        Mindful Living
                                                    </Typography>
                                                    <Chip
                                                        label="Webinar"
                                                        size="small"
                                                        sx={{
                                                            height: 18,
                                                            fontSize: '0.6rem',
                                                            fontWeight: 600,
                                                            bgcolor: '#e3f2fd',
                                                            color: '#0d47a1',
                                                            '& .MuiChip-label': { p: '0 6px' },
                                                            borderRadius: 1
                                                        }}
                                                    />
                                                </Box>
                                                <Typography variant="body2" sx={{ color: '#5f6368', fontSize: '0.81rem', mb: 1 }}>
                                                    {webinarData?.title || 'No webinars available at the moment.'}
                                                </Typography>
                                                <Typography variant="caption" sx={{ color: '#5f6368', fontSize: '0.7rem', display: 'block', mb: 1.5, lineHeight: 1.4 }}>
                                                    {webinarData?.description || 'Stay tuned for upcoming sessions!'}
                                                </Typography>
                                                {isWebinarRegistered ? (
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                        <Chip
                                                            label="Already Registered"
                                                            size="small"
                                                            sx={{
                                                                fontSize: '0.65rem',
                                                                fontWeight: 600,
                                                                bgcolor: '#e8f5e8',
                                                                color: '#2e7d32',
                                                                '& .MuiChip-label': { px: 1 },
                                                                borderRadius: 1.5
                                                            }}
                                                        />
                                                    </Box>
                                                ) : (
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        onClick={() => {
                                                            const user = JSON.parse(localStorage.getItem('user'));
                                                            // Remove: trackCTA('mindful_living', user); // Use webinar tracking instead
                                                            handleEventAction('webinar');
                                                        }}
                                                        sx={{
                                                            textTransform: 'none',
                                                            fontSize: '0.7rem',
                                                            background: 'linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)',
                                                            color: 'white',
                                                            py: 0.5,
                                                            px: 1.5,
                                                            borderRadius: 1.5,
                                                            fontWeight: 500,
                                                            boxShadow: '0 2px 6px rgba(26, 115, 232, 0.2)',
                                                            '&:hover': {
                                                                background: 'linear-gradient(135deg, #1557b0 0%, #0d47a1 100%)'
                                                            }
                                                        }}
                                                    >
                                                        Register Now
                                                    </Button>
                                                )}
                                            </Box> */}
                                                <Box sx={{ flex: 1 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#0d47a1', mb: 0.5, fontSize: '0.9rem' }}>
                                                            {webinarData?.webinar_name || 'Webinar'}
                                                        </Typography>
                                                        <Chip
                                                            label="Webinar"
                                                            size="small"
                                                            sx={{
                                                                height: 18,
                                                                fontSize: '0.6rem',
                                                                fontWeight: 600,
                                                                bgcolor: '#e3f2fd',
                                                                color: '#0d47a1',
                                                                '& .MuiChip-label': { p: '0 6px' },
                                                                borderRadius: 1
                                                            }}
                                                        />
                                                    </Box>
                                                    <Typography variant="body2" sx={{ color: '#5f6368', fontSize: '0.81rem', mb: 1 }}>
                                                        {webinarData?.title || 'No webinars available at the moment.'}
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ color: '#5f6368', fontSize: '0.7rem', display: 'block', mb: 1.5, lineHeight: 1.4 }}>
                                                        {webinarData?.description || 'Stay tuned for upcoming sessions!'}
                                                    </Typography>
                                                    {webinarData?.webinar_name &&
                                                        webinarData?.title &&
                                                        webinarData?.description && (

                                                            isWebinarRegistered ? (
                                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                    <Chip
                                                                        label="Already Registered"
                                                                        size="small"
                                                                        sx={{
                                                                            fontSize: '0.65rem',
                                                                            fontWeight: 600,
                                                                            bgcolor: '#e8f5e8',
                                                                            color: '#2e7d32',
                                                                            '& .MuiChip-label': { px: 1 },
                                                                            borderRadius: 1.5
                                                                        }}
                                                                    />
                                                                </Box>
                                                            ) : (
                                                                <Button
                                                                    variant="contained"
                                                                    size="small"
                                                                    disabled={isExpiredForAccount5}
                                                                    onClick={() => {
                                                                        if (isExpiredForAccount5) return;

                                                                        const user = JSON.parse(localStorage.getItem('user'));
                                                                        trackCTA('mindful_living', user, window.location.pathname);
                                                                        handleEventAction('webinar');
                                                                    }}
                                                                    sx={{
                                                                        textTransform: 'none',
                                                                        fontSize: '0.7rem',
                                                                        background: isExpiredForAccount5
                                                                            ? '#cbd5e1'
                                                                            : 'linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)',
                                                                        color: 'white',
                                                                        py: 0.5,
                                                                        px: 1.5,
                                                                        borderRadius: 1.5,
                                                                        fontWeight: 500,
                                                                        boxShadow: isExpiredForAccount5
                                                                            ? 'none'
                                                                            : '0 2px 6px rgba(26, 115, 232, 0.2)',
                                                                        '&:hover': {
                                                                            background: isExpiredForAccount5
                                                                                ? '#cbd5e1'
                                                                                : 'linear-gradient(135deg, #1557b0 0%, #0d47a1 100%)'
                                                                        }
                                                                    }}
                                                                >
                                                                    {isExpiredForAccount5 ? 'Registration Closed' : 'Register Now'}
                                                                </Button>
                                                            ))}
                                                </Box>
                                            </Box>
                                        </Card>
                                    )}

                                    {/* Podcast Card */}
                                    {!isRvce && (
                                        <Card
                                            elevation={0}
                                            sx={{
                                                p: 2,
                                                borderRadius: 2.5,
                                                border: '1px solid #E5E7EB',
                                                background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
                                                transition: 'all 0.3s ease-in-out',
                                                '&:hover': {
                                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                                    transform: 'translateY(-1px)'
                                                }
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                                <Box sx={{
                                                    width: 36,
                                                    height: 36,
                                                    borderRadius: 2,
                                                    background: "#7843f3",
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    mr: 1.5,
                                                    flexShrink: 0,
                                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                                }}>
                                                    <HeadphonesIcon sx={{ color: 'white', fontSize: 18 }} />
                                                </Box>
                                                <Box sx={{ flex: 1 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                        <Typography variant="subtitle2"
                                                            sx={{
                                                                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                                                WebkitBackgroundClip: 'text',
                                                                WebkitTextFillColor: 'transparent',
                                                                fontWeight: 700, mb: 0.5, fontSize: '0.9rem'
                                                            }}>
                                                            Learn with Echo
                                                        </Typography>
                                                        <Chip
                                                            label="Podcast"
                                                            size="small"
                                                            sx={{
                                                                height: 18,
                                                                fontSize: '0.6rem',
                                                                fontWeight: 600,
                                                                bgcolor: '#7843f3',
                                                                color: '#fff',
                                                                '& .MuiChip-label': { p: '0 6px' },
                                                                borderRadius: 1
                                                            }}
                                                        />
                                                    </Box>
                                                    <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '0.75rem', mb: 1 }}>
                                                        Latest Episode •  Available Now
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ color: '#5f6368', fontSize: '0.7rem', display: 'block', mb: 1.5, lineHeight: 1.4 }}>
                                                        Tune in to our fortnightly podcast series featuring mental health experts, personal stories, and practical tips for wellbeing.
                                                    </Typography>
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        onClick={handleListenNow}
                                                        sx={{
                                                            textTransform: 'none',
                                                            fontSize: '0.7rem',
                                                            background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                                            color: 'white',
                                                            py: 0.5,
                                                            px: 1.5,
                                                            borderRadius: 1.5,
                                                            fontWeight: 500,
                                                            boxShadow: '0 2px 6px rgba(255, 152, 0, 0.2)',
                                                            '&:hover': {
                                                                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                                            }
                                                        }}
                                                    >
                                                        Listen Now
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </Card>
                                    )}

                                </Box>

                            </Box>
                        )}
                    </Box>

                    {/* Vertical Divider */}
                    {!isTablet && <Divider orientation="vertical" flexItem />}

                    {!isTablet &&
                        <Box sx={{
                            flex: isTablet ? '1 1 100%' : '1 1 30%',
                            width: '100%',
                            maxWidth: isTablet ? '100%' : '30%',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: { xs: 2, sm: 2.5 },
                            '& > *': {
                                flexShrink: 0
                            }
                        }}>
                            <Box sx={{
                                display: 'flex', alignItems: 'center', mb: 2, p: 1.5, background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                borderRadius: 2, boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)', border: '1px solid #e3f2fd', color: '#fff',
                            }}>
                                <EventAvailableIcon sx={{ color: '#fff', mr: 1, fontSize: 20 }} />
                                <Typography variant="subtitle1" sx={{ color: '#fff', fontWeight: 600, fontSize: '0.95rem', }}>
                                    Events
                                </Typography>
                            </Box>

                            <Box sx={{ display: 'grid', gap: { xs: 1.5, sm: 2 } }}>
                                {isRvce && (
                                    <Card
                                        elevation={0}
                                        sx={{
                                            p: 2,
                                            borderRadius: 2.5,
                                            border: '1px solid #E5E7EB',
                                            background: 'linear-gradient(135deg, #f0fff4 0%, #e6ffed 100%)',
                                            transition: 'all 0.3s ease-in-out',
                                            '&:hover': {
                                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                                transform: 'translateY(-1px)'
                                            }
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <Box sx={{
                                                width: 36,
                                                height: 36,
                                                borderRadius: 2,
                                                background: 'linear-gradient(135deg, #22c55e, #14b8a6)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                mr: 1.5,
                                                flexShrink: 0,
                                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                            }}>
                                                <EventAvailableIcon sx={{ color: 'white', fontSize: 18 }} />
                                            </Box>
                                            <Box sx={{ flex: 1 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#166534', mb: 0.5, fontSize: '0.9rem' }}>
                                                        Monthly Engagement
                                                    </Typography>
                                                    <Chip
                                                        label="Monthly"
                                                        size="small"
                                                        sx={{
                                                            height: 18,
                                                            fontSize: '0.6rem',
                                                            fontWeight: 600,
                                                            bgcolor: '#dcfce7',
                                                            color: '#166534',
                                                            '& .MuiChip-label': { p: '0 6px' },
                                                            borderRadius: 1
                                                        }}
                                                    />
                                                </Box>
                                                <Typography variant="body2" sx={{ color: '#5f6368', fontSize: '0.81rem', mb: 1 }}>
                                                    No sessions scheduled at the moment.
                                                </Typography>
                                                <Typography variant="caption" sx={{ color: '#5f6368', fontSize: '0.7rem', display: 'block', lineHeight: 1.4 }}>
                                                    Stay tuned for upcoming engagement activities!
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Card>
                                )}
                                {!isRvce && (
                                    <Card
                                        elevation={0}
                                        sx={{
                                            p: 2,
                                            borderRadius: 2.5,
                                            border: '1px solid #E5E7EB',
                                            background: 'linear-gradient(135deg, #f0f7ff 0%, #e1f0ff 100%)',
                                            transition: 'all 0.3s ease-in-out',
                                            '&:hover': {
                                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                                transform: 'translateY(-1px)'
                                            }
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <Box sx={{
                                                width: 36,
                                                height: 36,
                                                borderRadius: 2,
                                                background: 'linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                mr: 1.5,
                                                flexShrink: 0,
                                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                            }}>
                                                <WebIcon sx={{ color: 'white', fontSize: 18 }} />
                                            </Box>
                                            {/* <Box sx={{ flex: 1 }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#0d47a1', mb: 0.5, fontSize: '0.9rem' }}>
                                                    Mindful Living
                                                </Typography>
                                                <Chip
                                                    label="Webinar"
                                                    size="small"
                                                    sx={{
                                                        height: 18,
                                                        fontSize: '0.6rem',
                                                        fontWeight: 600,
                                                        bgcolor: '#e3f2fd',
                                                        color: '#0d47a1',
                                                        '& .MuiChip-label': { p: '0 6px' },
                                                        borderRadius: 1
                                                    }}
                                                />
                                            </Box>
                                            <Typography variant="body2" sx={{ color: '#5f6368', fontSize: '0.81rem', mb: 1 }}>
                                                {webinarData?.title || 'No webinars available at the moment.'}
                                            </Typography>
                                            <Typography variant="caption" sx={{ color: '#5f6368', fontSize: '0.7rem', display: 'block', mb: 1.5, lineHeight: 1.4 }}>
                                                {webinarData?.description || 'Stay tuned for upcoming sessions!'}
                                            </Typography>
                                            {isWebinarRegistered ? (
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <Chip
                                                        label="Already Registered"
                                                        size="small"
                                                        sx={{
                                                            fontSize: '0.65rem',
                                                            fontWeight: 600,
                                                            bgcolor: '#e8f5e8',
                                                            color: '#2e7d32',
                                                            '& .MuiChip-label': { px: 1 },
                                                            borderRadius: 1.5
                                                        }}
                                                    />
                                                </Box>
                                            ) : (
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    onClick={() => {
                                                        const user = JSON.parse(localStorage.getItem('user'));
                                                        // Remove: trackCTA('mindful_living', user); // Duplicate - already tracked above
                                                        handleEventAction('webinar');
                                                    }}
                                                    sx={{
                                                        textTransform: 'none',
                                                        fontSize: '0.7rem',
                                                        background: 'linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)',
                                                        color: 'white',
                                                        py: 0.5,
                                                        px: 1.5,
                                                        borderRadius: 1.5,
                                                        fontWeight: 500,
                                                        boxShadow: '0 2px 6px rgba(26, 115, 232, 0.2)',
                                                        '&:hover': {
                                                            background: 'linear-gradient(135deg, #1557b0 0%, #0d47a1 100%)'
                                                        }
                                                    }}
                                                >
                                                    Register Now
                                                </Button>
                                            )}
                                        </Box> */}
                                            <Box sx={{ flex: 1 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#0d47a1', mb: 0.5, fontSize: '0.9rem' }}>
                                                        {webinarData?.webinar_name || 'Webinar'}
                                                    </Typography>
                                                    <Chip
                                                        label="Webinar"
                                                        size="small"
                                                        sx={{
                                                            height: 18,
                                                            fontSize: '0.6rem',
                                                            fontWeight: 600,
                                                            bgcolor: '#e3f2fd',
                                                            color: '#0d47a1',
                                                            '& .MuiChip-label': { p: '0 6px' },
                                                            borderRadius: 1
                                                        }}
                                                    />
                                                </Box>
                                                <Typography variant="body2" sx={{ color: '#5f6368', fontSize: '0.81rem', mb: 1 }}>
                                                    {webinarData?.title || 'No webinars available at the moment.'}
                                                </Typography>
                                                <Typography variant="caption" sx={{ color: '#5f6368', fontSize: '0.7rem', display: 'block', mb: 1.5, lineHeight: 1.4 }}>
                                                    {webinarData?.description || 'Stay tuned for upcoming sessions!'}
                                                </Typography>
                                                {webinarData?.webinar_name &&
                                                    webinarData?.title &&
                                                    webinarData?.description && (

                                                        isWebinarRegistered ? (
                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                <Chip
                                                                    label="Already Registered"
                                                                    size="small"
                                                                    sx={{
                                                                        fontSize: '0.65rem',
                                                                        fontWeight: 600,
                                                                        bgcolor: '#e8f5e8',
                                                                        color: '#2e7d32',
                                                                        '& .MuiChip-label': { px: 1 },
                                                                        borderRadius: 1.5
                                                                    }}
                                                                />
                                                            </Box>
                                                        ) : (
                                                            <Button
                                                                variant="contained"
                                                                size="small"
                                                                disabled={isExpiredForAccount5}
                                                                onClick={() => {
                                                                    if (isExpiredForAccount5) return;

                                                                    const user = JSON.parse(localStorage.getItem('user'));
                                                                    trackCTA('mindful_living', user, window.location.pathname);
                                                                    handleEventAction('webinar');
                                                                }}
                                                                sx={{
                                                                    textTransform: 'none',
                                                                    fontSize: '0.7rem',
                                                                    background: isExpiredForAccount5
                                                                        ? '#cbd5e1'
                                                                        : 'linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)',
                                                                    color: 'white',
                                                                    py: 0.5,
                                                                    px: 1.5,
                                                                    borderRadius: 1.5,
                                                                    fontWeight: 500,
                                                                    boxShadow: isExpiredForAccount5
                                                                        ? 'none'
                                                                        : '0 2px 6px rgba(26, 115, 232, 0.2)',
                                                                    '&:hover': {
                                                                        background: isExpiredForAccount5
                                                                            ? '#cbd5e1'
                                                                            : 'linear-gradient(135deg, #1557b0 0%, #0d47a1 100%)'
                                                                    }
                                                                }}
                                                            >
                                                                {isExpiredForAccount5 ? 'Registration Closed' : 'Register Now'}
                                                            </Button>
                                                        ))}
                                            </Box>
                                        </Box>
                                    </Card>
                                )}

                                {/* Podcast Card */}
                                <Card
                                    elevation={0}
                                    sx={{
                                        p: 2,
                                        borderRadius: 2.5,
                                        border: '1px solid #E5E7EB',
                                        background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
                                        transition: 'all 0.3s ease-in-out',
                                        '&:hover': {
                                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                            transform: 'translateY(-1px)'
                                        }
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <Box sx={{
                                            width: 36,
                                            height: 36,
                                            borderRadius: 2,
                                            background: "#7843f3",
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            mr: 1.5,
                                            flexShrink: 0,
                                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                        }}>
                                            <HeadphonesIcon sx={{ color: 'white', fontSize: 18 }} />
                                        </Box>
                                        <Box sx={{ flex: 1 }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <Typography variant="subtitle2"
                                                    sx={{
                                                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                                        WebkitBackgroundClip: 'text',
                                                        WebkitTextFillColor: 'transparent',
                                                        fontWeight: 700, mb: 0.5, fontSize: '0.9rem'
                                                    }}>
                                                    Learn with Echo
                                                </Typography>
                                                <Chip
                                                    label="Podcast"
                                                    size="small"
                                                    sx={{
                                                        height: 18,
                                                        fontSize: '0.6rem',
                                                        fontWeight: 600,
                                                        bgcolor: '#7843f3',
                                                        color: '#fff',
                                                        '& .MuiChip-label': { p: '0 6px' },
                                                        borderRadius: 1
                                                    }}
                                                />
                                            </Box>
                                            <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '0.75rem', mb: 1 }}>
                                                Latest Episode •  Available Now
                                            </Typography>
                                            <Typography variant="caption" sx={{ color: '#5f6368', fontSize: '0.7rem', display: 'block', mb: 1.5, lineHeight: 1.4 }}>
                                                Tune in to our fortnightly podcast series featuring mental health experts, personal stories, and practical tips for wellbeing.
                                            </Typography>
                                            <Button
                                                variant="contained"
                                                size="small"
                                                onClick={handleListenNow}
                                                sx={{
                                                    textTransform: 'none',
                                                    fontSize: '0.7rem',
                                                    background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                                    color: 'white',
                                                    py: 0.5,
                                                    px: 1.5,
                                                    borderRadius: 1.5,
                                                    fontWeight: 500,
                                                    boxShadow: '0 2px 6px rgba(255, 152, 0, 0.2)',
                                                    '&:hover': {
                                                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                                    }
                                                }}
                                            >
                                                Listen Now
                                            </Button>
                                        </Box>
                                    </Box>
                                </Card>

                                {/* Yoga Event Card */}
                                {/* <Card
                            elevation={0}
                            sx={{
                                p: 2,
                                borderRadius: 2.5,
                                border: '1px solid #C8E6C9',
                                background: 'linear-gradient(135deg, #f1f8e9 0%, #dcedc8 100%)',
                                transition: 'all 0.3s ease-in-out',
                                '&:hover': {
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                                    transform: 'translateY(-1px)'
                                }
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                <Box sx={{
                                    width: 36,
                                    height: 36,
                                    borderRadius: 2,
                                    background: 'linear-gradient(135deg, #4CAF50 0%, #388E3C 100%)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 1.5,
                                    flexShrink: 0,
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                }}>
                                    <SpaIcon sx={{ color: 'white', fontSize: 18 }} />
                                </Box>
                                <Box sx={{ flex: 1 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1b5e20', mb: 0.5, fontSize: '0.9rem' }}>
                                            Daily Yoga
                                        </Typography>
                                        <Chip
                                            label="Event"
                                            size="small"
                                            sx={{
                                                height: 18,
                                                fontSize: '0.6rem',
                                                fontWeight: 600,
                                                bgcolor: '#e8f5e9',
                                                color: '#2e7d32',
                                                '& .MuiChip-label': { p: '0 6px' },
                                                borderRadius: 1
                                            }}
                                        />
                                    </Box>
                                    <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '0.75rem', mb: 1 }}>
                                        {getTomorrow().date} • 7:30 AM • {getTomorrow().duration} • Live Session
                                    </Typography>
                                    <Typography variant="caption" sx={{ color: '#4B5563', fontSize: '0.7rem', display: 'block', mb: 1, lineHeight: 1.3 }}>
                                        Start your day with gentle yoga to improve flexibility, reduce stress, and enhance mindfulness.
                                    </Typography>
                                    {(() => {
                                        const now = new Date();
                                        const hours = now.getHours();
                                        const minutes = now.getMinutes();
                                        const currentTime = hours * 60 + minutes;
                                        
                                        // Enable from 7:30 AM to 11:59 PM
                                        const startTime = 7 * 60 + 30;  // 7:30 AM in minutes
                                        const endTime = 23 * 60 + 59;   // 11:59 PM in minutes
                                        const isActive = currentTime >= startTime && currentTime <= endTime;

                                        return (
                                            <Button
                                                variant="contained"
                                                size="small"
                                                onClick={() => handleEventAction('yoga')}
                                                disabled={!isActive}
                                                sx={{
                                                    textTransform: 'none',
                                                    fontSize: '0.7rem',
                                                    background: isActive
                                                        ? 'linear-gradient(135deg, #4CAF50 0%, #388E3C 100%)'
                                                        : 'linear-gradient(135deg, #9E9E9E 0%, #757575 100%)',
                                                    color: 'white',
                                                    py: 0.5,
                                                    px: 1.5,
                                                    borderRadius: 1.5,
                                                    fontWeight: 500,
                                                    boxShadow: '0 2px 6px rgba(76, 175, 80, 0.2)',
                                                    '&:hover': isActive ? {
                                                        background: 'linear-gradient(135deg, #388E3C 0%, #2E7D32 100%)'
                                                    } : {},
                                                    '&.Mui-disabled': {
                                                        background: 'linear-gradient(135deg, #e0e0e0 0%, #bdbdbd 100%)',
                                                        color: '#9e9e9e'
                                                    }
                                                }}
                                            >
                                                {isActive ? 'Join' : 'Join at 7:30 AM'}
                                            </Button>
                                        );
                                    })()}
                                </Box>
                            </Box>
                        </Card> */}
                            </Box>

                        </Box>
                    }
                </Box>

                <Dialog
                    open={isPodcastOpen}
                    onClose={() => setIsPodcastOpen(false)}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogContent sx={{ p: 0 }}>
                        <Box sx={{ p: 3, }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    mb: 2,
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: "bold",
                                        background: "linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    Learn with Echo podcast
                                </Typography>

                                <IconButton
                                    onClick={() => setIsPodcastOpen(false)}
                                    size="small"
                                    sx={{ color: "grey.600" }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Box>

                            <Box sx={{ mb: 3, borderRadius: 2, overflow: 'hidden', boxShadow: 3 }}>
                                <img
                                    // src="https://images.unsplash.com/photo-1478737270239-2f02b77fc618?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80"
                                    src="/podcast-image.avif"
                                    alt="Podcast Cover"
                                    style={{ width: '100%', height: '200px', objectFit: 'cover' }}
                                />
                            </Box>

                            <Typography
                                variant="h6"
                                sx={{ mb: 1, fontWeight: "medium", textAlign: "center" }}
                            >
                                {podcast?.title}
                            </Typography>

                            <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{ mb: 3, textAlign: "center" }}
                            >
                                {podcast?.description}
                            </Typography>

                            <Box sx={{ mb: 2 }}>
                                <audio
                                    controls
                                    controlsList="nodownload"
                                    src={podcast?.podcast_url}
                                    style={{ width: "100%" }}
                                    onLoadedMetadata={(e) => setDuration(e.target.duration)}
                                    onEnded={() => {
                                        console.log("Audio ended");
                                    }}
                                />
                            </Box>


                        </Box>
                    </DialogContent>
                </Dialog>

                {/* Event Modal for upcoming events */}
                <EventModal
                    open={eventModalOpen}
                    onClose={handleCloseEventModal}
                    eventType={selectedEvent}
                    eventTitle={selectedEvent === 'webinar' ? 'Mindful Living Webinar' : selectedEvent === 'therapy' ? 'Therapy Session' : 'Daily Yoga'}
                    eventIcon={selectedEvent === 'webinar' ? <WebIcon sx={{ color: 'white', fontSize: 20 }} /> : selectedEvent === 'therapy' ? <PsychologyIcon sx={{ color: 'white', fontSize: 20 }} /> : <SpaIcon sx={{ color: 'white', fontSize: 20 }} />}
                    showVideo={selectedEvent === 'yoga'}
                    currentUser={currentUser} setCurrentUser={setCurrentUser}
                />

                {/* Yoga Video Player Dialog */}
                <Dialog
                    open={isYogaVideoOpen}
                    onClose={() => {
                        setIsYogaVideoOpen(false);
                        if (videoRef.current) {
                            videoRef.current.pause();
                            videoRef.current.currentTime = 0;
                        }
                        setIsVideoPlaying(false);
                    }}
                    maxWidth={false} // disable default breakpoints
                    PaperProps={{
                        sx: {
                            backgroundColor: '#000',
                            borderRadius: 2,
                            width: 'fit-content',   // popup shrinks to video width
                            maxWidth: '900px',       // responsive for smaller screens
                            overflow: 'hidden',
                        }
                    }}
                >
                    <DialogTitle sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        background: '#000',
                        color: 'white',
                        p: 2,
                        borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
                    }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Box sx={{
                                width: 36,
                                height: 36,
                                borderRadius: '10px',
                                background: 'linear-gradient(135deg, #4CAF50 0%, #388E3C 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                            }}>
                                <SpaIcon sx={{ color: 'white', fontSize: 18 }} />
                            </Box>
                            <Box>
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                    {scheduledVideo?.title || 'Daily Yoga Session'}
                                </Typography>
                                <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)', display: 'block' }}>
                                    {scheduledVideo?.description || 'Daily yoga practice'}
                                </Typography>
                            </Box>
                        </Box>
                        <IconButton
                            onClick={() => setIsYogaVideoOpen(false)}
                            sx={{ color: 'white' }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent sx={{ p: 0, backgroundColor: '#000' }}>
                        {/* <Box
                        ref={containerRef}
                        sx={{
                            position: 'relative',
                            width: 'fit-content',  // shrink to video width
                            height: 'auto',        // adjust height automatically
                            margin: 'auto',
                        }}
                    > */}

                        {/* 13 nov  */}
                        <Box
                            ref={containerRef}
                            sx={{
                                position: isFullscreen ? 'fixed' : 'relative',
                                top: isFullscreen ? 0 : 'auto',
                                left: isFullscreen ? 0 : 'auto',
                                width: isFullscreen ? '100vw' : 'fit-content',
                                height: isFullscreen ? '100vh' : 'auto',
                                backgroundColor: '#000',
                                zIndex: isFullscreen ? 1400 : 'auto',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                overflow: 'hidden',
                                transition: 'all 0.3s ease-in-out',
                                margin: 'auto',
                            }}
                        >


                            {/*   //videoooo */}
                            <Box
                                component="video"
                                ref={videoRef}
                                src={scheduledVideo?.video}
                                autoPlay
                                playsInline
                                x-webkit-airplay="allow"
                                x5-video-player-type="h5"
                                x5-video-orientation="landscape"
                                x5-video-player-fullscreen="true"
                                muted={muted}
                                controls={false}
                                disablePictureInPicture
                                onPlay={handlePlay}
                                onLoadedMetadata={() => {
                                    const offset = getVideoStartTimeOffset();
                                    if (offset !== null && videoRef.current) {
                                        videoRef.current.currentTime = offset;
                                    }
                                }}
                                sx={{
                                    display: 'block',
                                    width: '100%',
                                    height: 'auto',
                                    maxHeight: isFullscreen ? '100vh' : 'auto',
                                    objectFit: 'contain',
                                }}
                            />
                            {/* Fullscreen button */}

                            <IconButton
                                onClick={() => handleFullscreenToggle()} // ✅ one unified call
                                sx={{
                                    position: 'absolute',
                                    bottom: 16,
                                    right: 16,
                                    color: 'white',
                                    backgroundColor: 'rgba(0,0,0,0.5)',
                                }}
                            >
                                {isMobileDevice() ? <ScreenRotation /> : <FullscreenIcon />}
                            </IconButton>

                            {/* <IconButton
                            onClick={() => {
                                if (isIOS() && videoRef.current?.webkitEnterFullscreen) {
                                    videoRef.current.webkitEnterFullscreen(); // Keep iOS-specific handling on video
                                } else {
                                    handleFullscreenToggle(); // Use container for standard fullscreen
                                }
                            }}
                            sx={{
                                position: 'absolute',
                                bottom: 16,
                                right: 16,
                                color: 'white',
                                backgroundColor: 'rgba(0,0,0,0.5)',
                            }}
                        >
                            {isMobileDevice() ? <ScreenRotation /> : <FullscreenIcon />}
                        </IconButton> */}


                            {/* Mute/Unmute button */}
                            <IconButton
                                onClick={toggleMute}
                                sx={{
                                    position: 'absolute',
                                    bottom: 16,
                                    right: 64,
                                    color: 'white',
                                    backgroundColor: 'rgba(0,0,0,0.5)',
                                }}
                            >
                                {muted ? <VolumeOffIcon /> : <VolumeUpIcon />}
                            </IconButton>
                            {isFullscreen && (
                                <IconButton
                                    onClick={() => setIsYogaVideoOpen(false)}
                                    sx={{
                                        position: 'fixed',
                                        top: 16,
                                        right: 16,
                                        color: 'white',
                                        backgroundColor: 'rgba(0,0,0,0.5)',
                                        zIndex: 1400,
                                        '&:hover': {
                                            backgroundColor: 'rgba(0,0,0,0.7)',
                                        }
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            )}
                        </Box>

                    </DialogContent>
                </Dialog>

                <SmartBiometricTherapyDialog
                    open={openDialog}
                    onClose={() => setOpenDialog(false)}
                />

                <Dialog
                    open={open}
                    onClose={handleClose}
                    PaperProps={{
                        sx: { borderRadius: 3, p: { xs: 0, sm: 2 }, minWidth: { xs: 280, sm: 400 } },
                    }}
                >
                    {/* Warning Icon */}
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                        <WarningAmberIcon sx={{ color: "#FFA000", fontSize: 48 }} />
                    </Box>

                    {/* Title */}
                    <DialogTitle sx={{ textAlign: "center", mt: { xs: 0, sm: 1 }, fontWeight: 'bold' }}>
                        Are you sure?
                    </DialogTitle>

                    {/* Content */}
                    <DialogContent>
                        <DialogContentText sx={{ textAlign: "center", fontSize: 16 }}>
                            Click <strong>Dial Now</strong> for mobile users or dial <strong>{phoneNumber}</strong> to receive a callback ASAP for non-mobile users.
                        </DialogContentText>
                    </DialogContent>

                    {/* Actions */}
                    <DialogActions sx={{ justifyContent: "center", gap: 2, mb: 1 }}>
                        <Button onClick={handleDialNow} color="secondary" variant="contained" sx={{ px: 4 }}>
                            Dial Now
                        </Button>
                        <Button onClick={handleClose} color="primary" variant="outlined" sx={{ px: 4 }}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Coming Soon Dialog for Insights */}
                <Dialog
                    open={isInsightsComingSoonOpen}
                    onClose={() => setIsInsightsComingSoonOpen(false)}
                    PaperProps={{
                        sx: {
                            borderRadius: 3,
                            p: { xs: 2, sm: 3 },
                            minWidth: { xs: 280, sm: 400 },
                            textAlign: 'center'
                        }
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                        <Box
                            sx={{
                                width: 80,
                                height: 80,
                                borderRadius: '50%',
                                background: 'linear-gradient(135deg, #4a6cf7 0%, #3b5bdb 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 8px 24px rgba(74, 108, 247, 0.3)'
                            }}
                        >
                            <InsightsIcon sx={{ color: 'white', fontSize: 40 }} />
                        </Box>
                    </Box>

                    <DialogTitle sx={{ textAlign: 'center', fontWeight: 700, fontSize: '1.5rem', pb: 1 }}>
                        Coming Soon!
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText sx={{ textAlign: 'center', fontSize: '1rem', color: 'text.secondary', mb: 2 }}>
                            We're working hard to bring you personalized insights and analytics.
                        </DialogContentText>
                        <DialogContentText sx={{ textAlign: 'center', fontSize: '0.9rem', color: 'text.secondary' }}>
                            Stay tuned for updates! 🚀
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
                        <Button
                            onClick={() => setIsInsightsComingSoonOpen(false)}
                            variant="contained"
                            sx={{
                                px: 4,
                                py: 1,
                                borderRadius: 2,
                                textTransform: 'none',
                                fontWeight: 600,
                                background: 'linear-gradient(135deg, #4a6cf7 0%, #3b5bdb 100%)',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #3b5bdb 0%, #2f4bbd 100%)'
                                }
                            }}
                        >
                            Got it!
                        </Button>
                    </DialogActions>
                </Dialog>
                <TermsAndConditions
                    open={isTermsOpen}
                    onClose={() => setIsTermsOpen(false)}
                    onAccept={handleAcceptYogaTerms}
                />

                {/* Contact Geetha Popup */}
                <Dialog
                    open={showContactPopup}
                    onClose={handleCloseContactPopup}
                    aria-labelledby="contact-geetha-dialog"
                    maxWidth="sm"
                    fullWidth
                    PaperProps={{
                        sx: {
                            borderRadius: 3,
                            p: 3,
                            background: 'linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%)',
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
                        }
                    }}
                >
                    <Box sx={{ textAlign: 'center', p: 2 }}>

                        <Typography variant="h5" sx={{ mb: 2, color: '#1a237e', fontWeight: 600 }}>
                            Contact Support
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 3, color: '#424242' }}>
                            Please contact Geetha at{' '}
                            <a
                                // href="mailto:geetha@diginxthlt.com" 
                                style={{
                                    color: '#1a73e8',
                                    textDecoration: 'none',
                                    fontWeight: 500
                                }}
                            >
                                @diginxthlt
                            </a>{' '}
                            for assistance with your consultation.
                        </Typography>
                        <Button
                            variant="contained"
                            onClick={handleCloseContactPopup}
                            sx={{
                                mt: 2,
                                px: 4,
                                py: 1.5,
                                borderRadius: 2,
                                fontWeight: 600,
                                background: 'linear-gradient(135deg, #4a90e2 0%, #1a73e8 100%)',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #3a80d2 0%, #0a63c8 100%)',
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                                }
                            }}
                        >
                            Close
                        </Button>
                    </Box>
                </Dialog>

            </Box>
        </Box >

    );
};

export default Home;
